// NOTE: This is a quick fix as webapp-locales utils has bug
export const TLD_TO_LOCALE: Record<string, string> = {
  '.com': 'en_US',
  '.ca': 'en_CA',
  '.com.ar': 'es_AR',
  '.com.br': 'pt_BR',
  '.cl': 'es_CL',
  '.com.mx': 'es_MX',
  '.co': 'es_CO',
  '.com.pe': 'es_PE',
  '.co.uk': 'en_GB',
  '.ie': 'en_IE',
  '.de': 'de_DE',
  '.at': 'de_AT',
  '.es': 'es_ES',
  '.fr': 'fr_FR',
  '.it': 'it_IT',
  '.nl': 'nl_NL',
  '.be': 'nl_BE',
  '.pt': 'pt_PT',
  '.se': 'sv',
  '.com.au': 'en_AU',
  '.co.nz': 'en_NZ',
  '.com.hk': 'en_HK',
  '.sg': 'en_SG',
  '.fi': 'en_FI',
  '.dk': 'en_DK',
  '.ch': 'de_CH',
};
